export * from "./fetch-product-spec";
